import { useEffect, useState } from "react";
import { api, fmtMoney, today, daysAgo } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Input } from "@/components/ui/input";

export default function GSTReturns() {
    const [from, setFrom] = useState(daysAgo(90));
    const [to, setTo] = useState(today());
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/gst/summary", { params: { date_from: from, date_to: to } }).then(({ data }) => setData(data));
    }, [from, to]);

    return (
        <>
            <PageHeader kicker="TAXES" title="GST Returns" subtitle="Outward, inward, and net liability — ready for GSTR-1 / 3B prep."
                actions={<><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="w-[140px]" /><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-[140px]" /></>} />
            <PageBody>
                {data && (
                    <>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <Card title="Output GST (outward)" rows={[
                                ["Taxable supplies", data.outward.taxable], ["CGST", data.outward.cgst], ["SGST", data.outward.sgst], ["IGST", data.outward.igst], ["Total GST", data.outward.total_tax],
                            ]} />
                            <Card title="Input GST (inward)" rows={[
                                ["Taxable purchases", data.inward.taxable], ["CGST", data.inward.cgst], ["SGST", data.inward.sgst], ["IGST", data.inward.igst], ["Total ITC", data.inward.total_tax],
                            ]} />
                            <Card title="Net liability" rows={[
                                ["Output GST", data.outward.total_tax],
                                ["Less: ITC", -data.inward.total_tax],
                                ["Net payable", data.net_liability],
                            ]} accent />
                        </div>
                        <div className="bg-card border border-border rounded-md p-6 mt-4">
                            <h3 className="text-[17px] font-semibold mb-4">By rate</h3>
                            <table className="fin-table">
                                <thead><tr><th>Rate</th><th className="num">Taxable</th><th className="num">Tax</th></tr></thead>
                                <tbody>
                                    {data.by_rate.map((r) => (
                                        <tr key={r.rate}>
                                            <td className="font-mono">{r.rate}%</td>
                                            <td className="num">{fmtMoney(r.taxable)}</td>
                                            <td className="num">{fmtMoney(r.tax)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </PageBody>
        </>
    );
}

function Card({ title, rows, accent }) {
    return (
        <div className="bg-card border border-border rounded-md p-5">
            <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">{title}</div>
            <div className="mt-3 space-y-1.5">
                {rows.map(([k, v], i) => (
                    <div key={i} className={`flex justify-between text-[13px] ${i === rows.length - 1 ? "border-t border-border pt-2 mt-2 font-medium" : ""}`}>
                        <span className={i === rows.length - 1 ? "" : "text-muted-foreground"}>{k}</span>
                        <span className={`font-mono ${accent && i === rows.length - 1 ? "text-positive serif-num text-2xl" : ""}`}>{fmtMoney(v)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
